const PowerfulChoice = () => (
    <section id="powerful-choice">
        <div className="container-fluid pt-4 pb-4 text-center gg-bg-gradient-v text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>You’ve Just Made a Powerful Choice…</b></h3>
                    <h5 className="fw-light mb-4">You’ve taken the first step toward better blood sugar, better energy, better health.</h5>
                    <h5 className="fw-light mb-4">But there’s one more decision that could make all the difference in how well GlucoGen<sup>17</sup> works for you…</h5>
                    <h5 className="fw-light mb-4">And how quickly you start seeing results.</h5>
                </div>
            </div>
        </div>
    </section>
);

export default PowerfulChoice;